import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { debounce } from 'lodash-es';
import { catchError } from '../Actions/Error.action';
import { loadError, update } from '../Actions/Cart.action';
import { translate } from '../Services/translation';
import { Spinner } from './Spinner';

const MiniCartItem = ({
    orderItem,
    handleRemoveProduct,
    setShowError,
    showSpinner,
}) => {
    const dispatch = useDispatch();

    const [errorMessage, setErrorMessage] = useState('');
    const [cartQuantity, setCartQuantity] = useState(orderItem.quantity);
    const [showSpinnerCounter, setshowSpinnerCounter] = useState('');
    const mapCartToAbort = useRef({});

    const updateCart = useRef(
        debounce((rowSystemId, quantity) => {
            mapCartToAbort.current[rowSystemId] = new AbortController();
            dispatch(
                update(
                    rowSystemId,
                    quantity,
                    mapCartToAbort.current[rowSystemId]
                )
            ).catch((ex) => {
                setShowError(true);
                dispatch(catchError(ex, (error) => loadError(error)));
            });
        }, 500)
    ).current;

    useEffect(() => {
        setCartQuantity(orderItem.quantity);
    }, [orderItem.quantity]);

    useEffect(() => {
        setErrorMessage('');
        updateCart(orderItem.articleNumber, cartQuantity);
    }, [cartQuantity, orderItem.articleNumber, updateCart]);

    function decrement(articleNumber) {
        if (cartQuantity - orderItem.minArticleQuantity > 0) {
            setshowSpinnerCounter(articleNumber);
            setCartQuantity(cartQuantity - orderItem.minArticleQuantity);
            setTimeout(() => {
                setshowSpinnerCounter('');
            }, 1500);
            return;
        }
        setErrorMessage(translate('cart.item.quantity.minquantity'));
        setTimeout(() => {
            setErrorMessage('');
        }, 3000);
    }

    function increment(articleNumber) {
        setshowSpinnerCounter(articleNumber);
        let newTotal = cartQuantity + orderItem.minArticleQuantity;
        setCartQuantity(newTotal);
        setTimeout(() => {
            setshowSpinnerCounter('');
        }, 1500);
        return;
    }

    return (
        <div className="mini-cart__item">
            <img
                className="mini-cart__item-product-image"
                src={orderItem.image}
                alt={orderItem.name}
            />
            <div className="mini-cart__item-product-info-wrapper">
                <div className="mini-cart__item-product-info-top">
                    <a href={orderItem.url}>
                        <p className="mini-cart__item-product-info-title">
                            {orderItem.name}
                        </p>
                    </a>
                    {orderItem &&
                        orderItem.information &&
                        orderItem.information.map((x, index) => {
                            return (
                                <p
                                    className="checkout__article-information"
                                    key={index}
                                >
                                    {x}
                                </p>
                            );
                        })}
                    {showSpinnerCounter == orderItem.articleNumber ? (
                        <div className="mini-cart__spinner">
                            <Spinner />
                        </div>
                    ) : (
                        <>
                            {orderItem.campaignPrice ? (
                                <div>
                                    <p className="mini-cart__item-product-info-price--old">
                                        {orderItem.totalPrice}
                                    </p>
                                    <p className="mini-cart__item-product-info-price--discount">
                                        {orderItem.totalCampaignPrice}
                                    </p>
                                </div>
                            ) : (
                                <p className="mini-cart__item-product-info-price">
                                    {orderItem.totalPrice}
                                </p>
                            )}
                        </>
                    )}
                </div>
                <div className="mini-cart__item-product-info-bottom">
                    <div className="mini-cart__item-product-info-counter">
                        <button
                            type="button"
                            id="itemcounter-remove"
                            onClick={() => decrement(orderItem.articleNumber)}
                        >
                            -
                        </button>
                        <div id="itemcounter-current">{cartQuantity}</div>
                        <button
                            type="button"
                            id="itemcounter-add"
                            onClick={() => increment(orderItem.articleNumber)}
                        >
                            +
                        </button>
                    </div>

                    {showSpinner ? (
                        <Spinner />
                    ) : (
                        <>
                            <a
                                className="mini-cart__item-product-info-link"
                                onClick={() => handleRemoveProduct(orderItem)}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {translate('minicart.delete')}
                            </a>
                        </>
                    )}
                </div>
                {errorMessage && (
                    <span className="mini-cart__item-product-info-error-message">
                        {errorMessage}
                    </span>
                )}
            </div>
        </div>
    );
};

export default MiniCartItem;
